import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { AUTHENTICATE_ROUTES } from "@/views/authenticate/routes";
import { BASE_ROUTES } from "@/views/base/routes";
import store from '@/store';
 
Vue.use(VueRouter);
 
// Add a new route for the Flutter app
const FLUTTER_ROUTE: RouteConfig = {
  path: '/assessment',
  name: 'assessment',
  beforeEnter: (to, from, next) => {
    // Check if the user is authenticated before allowing access to the Flutter app
    //const token = store.state.Authenticate?.user?.token;
    //if (!token) {
    //  next({ path: '/login' });
    //} else {
      // Redirect to the Flutter app
      //window.location.href = '/flutter/';
    //}
  }
};
 
const routes: Array<RouteConfig> = [
  ...AUTHENTICATE_ROUTES,
  ...BASE_ROUTES,
  FLUTTER_ROUTE  // Add the Flutter route to the routes array
]
 
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});
 
router.beforeEach((to, from, next) => {
  const token = store.state.Authenticate?.user?.token;
  const publicPages = ["/login", "/assessment"];
  const authRequired = !publicPages.includes(to.path);
  if (authRequired && !token) {
    return next({ path: '/login'});
  }
  next();
});
 
export default router